import React, { useState, useEffect } from 'react';
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react';

const GlobalFeedback = () => {
  const [toasts, setToasts] = useState([]);
  const [confirmReq, setConfirmReq] = useState(null);

  useEffect(() => {
    const handleToast = (e) => {
      const id = Date.now() + Math.random();
      const newToast = { id, msg: e.detail.msg, type: e.detail.type };
      
      setToasts(prev => [...prev, newToast]);
      
      // Auto-remove toast after specified duration
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, e.detail.duration || 3000);
    };

    const handleConfirm = (e) => {
      setConfirmReq({
        msg: e.detail.msg,
        onConfirm: e.detail.onConfirm
      });
    };

    document.addEventListener('app-toast', handleToast);
    document.addEventListener('app-confirm', handleConfirm);

    return () => {
      document.removeEventListener('app-toast', handleToast);
      document.removeEventListener('app-confirm', handleConfirm);
    };
  }, []);

  const removeToast = (id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  };

  const handleConfirmAction = () => {
    if (confirmReq && confirmReq.onConfirm) {
      confirmReq.onConfirm();
    }
    setConfirmReq(null);
  };

  return (
    <>
      {/* Toast Container */}
      <div style={{ position: 'fixed', bottom: '20px', left: '50%', transform: 'translateX(-50%)', zIndex: 9999, display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center', pointerEvents: 'none' }}>
        {toasts.map(t => (
          <div key={t.id} className="card" style={{ 
            pointerEvents: 'auto',
            padding: '12px 20px', 
            borderRadius: '30px', 
            display: 'flex', 
            alignItems: 'center', 
            gap: '10px',
            backgroundColor: t.type === 'error' ? 'var(--danger-color)' : t.type === 'success' ? 'var(--secondary-color)' : 'var(--primary-color)',
            color: 'white',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            animation: 'slideUp 0.3s ease-out'
          }}>
            {t.type === 'success' && <CheckCircle size={20} />}
            {t.type === 'error' && <AlertCircle size={20} />}
            {t.type === 'info' && <Info size={20} />}
            <span style={{ fontWeight: '500', fontSize: '0.95rem' }}>{t.msg}</span>
            <button onClick={() => removeToast(t.id)} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', padding: 0, marginLeft: '10px', display: 'flex' }}>
              <X size={16} />
            </button>
          </div>
        ))}
      </div>

      {/* Confirm Modal */}
      {confirmReq && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
          <div className="card" style={{ width: '100%', maxWidth: '400px', padding: '1.5rem', animation: 'scaleIn 0.2s ease-out' }}>
            <h3 style={{ margin: '0 0 1rem 0', color: 'var(--text-primary)', textAlign: 'center' }}>Confirmation</h3>
            <p style={{ textAlign: 'center', color: 'var(--text-secondary)', marginBottom: '1.5rem', fontSize: '1.1rem' }}>
              {confirmReq.msg}
            </p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              <button className="btn" onClick={() => setConfirmReq(null)} style={{ flex: 1, backgroundColor: 'var(--bg-color)', color: 'var(--text-primary)', border: '1px solid var(--border-color)' }}>
                Annuler
              </button>
              <button className="btn btn-primary" onClick={handleConfirmAction} style={{ flex: 1 }}>
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes scaleIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </>
  );
};

export default GlobalFeedback;
